import React, { useState, useEffect, useMemo } from 'react';
import './ProductsGrid.css';
import ProductCard from './ProductCard';
import ProductsFilter from './ProductsFilter';
import { fetchProducts } from './productData';

export default function ProductsGrid({ onSelectProduct }) {
  const [products,       setProducts]       = useState([]);
  const [loading,        setLoading]        = useState(true);
  const [activeCategory, setActiveCategory] = useState('All');
  const [activeBrand,    setActiveBrand]    = useState('All Brands');
  const [sortBy,         setSortBy]         = useState('featured');

  useEffect(() => {
    fetchProducts()
      .then(data => setProducts(data))
      .catch(err  => console.error(err))
      .finally(()  => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    let list = [...products];

    if (activeCategory !== 'All')
      list = list.filter(p => p.category === activeCategory);

    if (activeBrand !== 'All Brands')
      list = list.filter(p => p.brand === activeBrand);

    if (sortBy === 'price-asc')  list.sort((a, b) => a.price - b.price);
    if (sortBy === 'price-desc') list.sort((a, b) => b.price - a.price);
    if (sortBy === 'name')       list.sort((a, b) => a.name.localeCompare(b.name));

    return list;
  }, [products, activeCategory, activeBrand, sortBy]);

  return (
    <>
      <ProductsFilter
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
        activeBrand={activeBrand}
        setActiveBrand={setActiveBrand}
        sortBy={sortBy}
        setSortBy={setSortBy}
        totalCount={filtered.length}
      />

      <div className="pg">
        <div className="pg__inner">
          {loading ? (
            <div className="pg__loading">
              <div className="pg__spinner" />
              <p>Loading drops...</p>
            </div>
          ) : filtered.length === 0 ? (
            <div className="pg__empty">
              <span className="pg__empty-icon">👟</span>
              <p>No styles match your filters.</p>
              <button onClick={() => { setActiveCategory('All'); setActiveBrand('All Brands'); }}>
                Clear filters
              </button>
            </div>
          ) : (
            <div className="pg__grid">
              {filtered.map(product => (
                <ProductCard
                  key={product.id}
                  product={product}
                  onClick={() => onSelectProduct(product)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}